import Utilities from '../helpers/utilities';

export default class RoleManager {

    constructor() {

        const urlVars = new Utilities().getUrlVars();
        
        const isReserveOnly = $('.roletype-toggle-container').hasClass('reserve-only');
        this.isReserve = false;
        if (isReserveOnly) {
            this.isReserve = true;
        }
        else {
            const timeParam = urlVars['time'] ? urlVars['time'].toLowerCase() : '';
            this.isReserve = (timeParam === 'reserve' || timeParam === 'reserves');
        }        

        this.syncToggleState();
        this.updateView();
        this.setEvents();
    }

    syncToggleState() {
        const $checkbox = $('.roletype-toggle-checkbox');
        if ($checkbox.length) {
            $checkbox.prop('checked', this.isReserve);
        }
        this.updateToggleColors();
    }

    updateToggleColors() {
        const $container = $('.roletype-toggle');
        if (this.isReserve) {
            $container.addClass('reserves');
        } else {
            $container.removeClass('reserves');
        }
    }

    setEvents() {
        const self = this;
        $('.roletype-toggle-checkbox').on('change', function() {
            self.isReserve = $(this).is(':checked');
            self.updateToggleColors();
            self.updateView();
        });
    }

    updateView() {
        $('div[data-forregular], div[data-forreserve]').hide();
        if (this.isReserve) {
            $('div[data-forreserve="True"]').show();
        } else {
            $('div[data-forregular="True"]').show();
        }
    }
}
